import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { Toaster } from "@/components/ui/toaster"
import { AuthProvider } from "@/auth/AuthContext"
import './index.css'
import App from './App.jsx'

// Import route components
import Login from "./auth/Login"
import Home from "./components/Company_Side/Home"
import ClientData from "./components/Company_Side/ClientData"
import Success from "./components/Company_Side/Success"
import ThankYou from "./components/ThankYou"
import Agents from "./components/Company_Side/Users"
import LeadsAgenti from "./components/Company_Side/AgentLeads"
import AdminLeads from "./components/Company_Side/AdminLeads"

import PrivateRoute from "./auth/PrivateRoute"
import AdminRoute from "./components/Company_Side/AdminRoute"
import AgentOnlyRoute from "./components/Company_Side/AgentOnlyRoute"
import CampaignManagerRoute from "./components/Company_Side/CampaignManagerRoute"
import BackofficeRoute from "./components/Company_Side/BackofficeRoute"
import CampaignManagerLeads from "./components/Company_Side/CampaignManagerLeads"
import EugenioChat from "./components/Company_Side/EugenioChat"
import EmailCreation from "./components/Company_Side/EmailCreation"
import EmailMarketing from "./components/Company_Side/EmailMarketing"
import AutomaticEmailCreation from "./components/Company_Side/AutomaticEmailCreation"
import Settings from "./components/Company_Side/Settings"
import DocumentRequest from "./components/Company_Side/DocumentRequest"
import MyDocumentRequests from "./components/Company_Side/MyDocumentRequests"
import Documenti from "./components/Company_Side/Documenti"
import Upload from "./components/Company_Side/Upload"
import Insights from "./components/Company_Side/Insights"
import PreventivatorePresPer from "./components/Company_Side/PreventivatorePresPer"
import PreventivatoreMutuo from "./components/Company_Side/PreventivatoreMutuo"
import TicketOpening from "./components/Company_Side/ticketOpening/ticketOpening.jsx"
import TicketsHome from "./components/Company_Side/ticketOpening/ticketsHome.jsx"
import MyTickets from "./components/Company_Side/ticketOpening/myTickets.jsx"

// Define routes using createBrowserRouter
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <div>404 - Page Not Found</div>,
    children: [
      /*
        Rutas originales comentadas a petición del usuario.
        Mantengo el bloque comentado para referencia futura.

        { path: "login", element: <Login /> },
        { path: "/", element: <PrivateRoute><Home /></PrivateRoute> },
        { path: "client-data", element: <PrivateRoute><ClientData /></PrivateRoute> },
        { path: "success", element: <PrivateRoute><Success /></PrivateRoute> },
        { path: "eugenio-chat", element: <PrivateRoute><EugenioChat /></PrivateRoute> },
        { path: "settings", element: <PrivateRoute><Settings /></PrivateRoute> },
        { path: "my-document-requests", element: <PrivateRoute><MyDocumentRequests /></PrivateRoute> },
        { path: "document-request", element: <PrivateRoute><DocumentRequest /></PrivateRoute> },
        { path: "insights", element: <PrivateRoute><Insights /></PrivateRoute> },
        { path: "upload/:id", element: <Upload /> },
        {
          path: "agent",
          element: <AgentOnlyRoute />,
          children: [
            { path: "my-leads", element: <LeadsAgenti /> },
            { path: "tickets", element: <TicketsHome /> },
            { path: "tickets/new", element: <TicketOpening /> },
            { path: "tickets/mine", element: <MyTickets />},
          ],
        },
        {
          element: <AdminRoute />,
          children: [
            { path: "users", element: <Agents /> },
            { path: "leads-campagne", element: <AdminLeads /> },
            { path: "tutti-i-documenti", element: <Documenti /> },
            { path: "email-marketing", element: <EmailMarketing /> },
            { path: "email-marketing/create", element: <EmailCreation /> },
            { path: "email-marketing/automatic-mails", element: <AutomaticEmailCreation /> },
          ],
        },
        { path: "preventivatore-prestito-personale", element: <PrivateRoute><PreventivatorePresPer /></PrivateRoute> },
        { path: "preventivatore-mutuo", element: <PrivateRoute><PreventivatoreMutuo /></PrivateRoute> },
        {
          element: <CampaignManagerRoute />,
          children: [
            { path: "campaign-leads", element: <CampaignManagerLeads /> },
          ],
        },
        {
          element: <BackofficeRoute />,
          children: [
            { path: "backoffice/home", element: <Home /> },
            { path: "backoffice/document-request", element: <DocumentRequest /> },
            { path: "backoffice/my-document-requests", element: <MyDocumentRequests /> },
            { path: "backoffice/documenti", element: <Documenti /> },
            { path: "backoffice/settings", element: <Settings /> },
            { path: "backoffice/client-data", element: <ClientData /> },
            { path: "backoffice/success", element: <Success /> },
            { path: "backoffice/preventivatore-prestito-personale", element: <PreventivatorePresPer />},
            { path: "backoffice/preventivatore-mutuo", element: <PreventivatoreMutuo /> }
          ],
        },
      */

      // Nueva única ruta expuesta al usuario: THANKYOU
      { path: "THANKYOU", element: <ThankYou /> },
      // Redirijo la raíz también a THANKYOU para que la app muestre la página vacía
      { path: "/", element: <ThankYou /> },
    ],
  },
]);

// Create root and render
const root = ReactDOM.createRoot(document.getElementById('root'))

// Remove initial spinner after app mounts
const removeSpinner = () => {
  const spinner = document.getElementById('initial-spinner')
  if (spinner) {
    spinner.remove()
  }
}

root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} onNavigate={removeSpinner} />
      <Toaster />
    </AuthProvider>
  </React.StrictMode>
)
